<template>
  <div>
    <label class="form-label">{{ label || "Select" }}</label>
    <select @change="emitFilter" class="form-control" :value="realValue">
      <option v-for="(option, index) in options" :key="index" :value="index">{{
        option.label
      }}</option>
    </select>
  </div>
</template>

<script lang="babel">
export default {
  props: {
    value: null,
    filter: null,
    label: null,
    id: null,
    attributes: null,
    options: {
      required: true,
      type: Array
    }
  },
  computed: {
    realValue() {
      if (!this.value) {
        return null;
      }

      return this.options.findIndex(option => JSON.stringify(option.filter[0].attributes) == JSON.stringify(this.value));
    }
  },
  methods: {
    emitFilter(event) {
      let selectedFilter = this.options[event.target.value].filter;
      if (selectedFilter && Array.isArray(selectedFilter)) {
        selectedFilter.forEach(filter => {
          filter.id = this.id;

          this.$emit("filter-change", filter);
        });
      }
    }
  }
};
</script>
